/* eslint-disable react/prop-types */
import React from 'react';
import { Body } from 'Organisms';

export const getBody = ({
  bodyInjected = [],
  template = 'article',
  disableAdInjections = false,
  bottomComponents = [],
  layoutType = 'default',
  topComponents,
  isMobile,
}) => (
  <Body
    bodyInjected={bodyInjected}
    template={template}
    disableAdInjections={disableAdInjections}
    bottomComponents={bottomComponents}
    layoutType={layoutType}
    topComponents={topComponents}
    isMobile={isMobile}
  />
);
